export const VMM_URL_BASE = "https://vmm.vlaanderen.be";
